// modules/CloseButton.js
import React         from 'react';

class CloseButton extends React.Component {
	render() {
			return (
				<a href={this.props.path} className="lfss-close" onClick={(e) => this.props.onClick(e)}>
					<svg className="lfss-close-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path d="M0,0L20,20z"/>
						<path d="M0,20L20,0z"/>
					</svg>
				</a>
			);
	}
}

export default CloseButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/CloseButton.js
 **/